module.exports = __webpack_public_path__ + "static/media/Cover.94516194.png";